//mypreset.ts
import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

const MyPreset = definePreset(Aura, {
    font: {
        family: "'Inter', sans-serif"
    },
    semantic: {
        formField: {
            borderRadius: '2rem'
        },
        primary: {
            50:  '#deefef',
            100: '#bddee1',
            200: '#9ccdd3',
            300: '#7abcc4',
            400: '#59acb5',
            500: '#389ba6',
            600: '#2f818a',
            700: '#25676f',
            800: '#1c4e53',
            900: '#133437',
            950: '#0f2729'
        },
        colorScheme: {
            light: {
                primary: {
                    color: '{primary.500}',
                    contrastColor: '#ffffff',
                    hoverColor: '{primary.600}',
                    activeColor: '{primary.700}'
                }
            }
        }
    },
    components: {
        button: {
            root: {
                borderRadius: '3rem',
                paddingX: '1.25rem',
                paddingY: '0.6875rem',
            }
        }
    }
});

export default MyPreset;
